import orderBy from 'lodash/fp/orderBy'
import first from 'lodash/fp/first'
import { createSelector } from 'reselect';
import {
  getOrEmptyObject,
  createIsRequestingSelector,
  createErrorSelector,
  createResultsSelector,
  createSelectorOrNull
} from '../../utils/selectors'
import { createEntitiesSelector } from '../../utils/normalize'
import { selectLoginTokenData } from '../Login/selectors'
import { applicationSchemas } from './schema'
import { REDUCER_KEY } from './reducer'

export const selectApplicationsState = getOrEmptyObject(REDUCER_KEY)

export const isApplicationsRequesting = createIsRequestingSelector(selectApplicationsState)()
export const selectApllicationsError = createErrorSelector(selectApplicationsState)()
export const isHaciendaBlocked = createIsRequestingSelector(selectApplicationsState)('isHaciendaBlocked')

export const selectApplicationsIds = createResultsSelector(selectApplicationsState)('all')
export const selectCurrentApplicationId = createSelectorOrNull(selectApplicationsState)('current')

export const selectApplications = createEntitiesSelector(
  selectApplicationsIds,
  applicationSchemas.denormalizeList
)

export const selectUserApplications = createSelector(
  selectLoginTokenData,
  selectApplications,
  (user, applications) => applications.filter(apply => apply.user_id === user.id)
)

export const selectUserSortedApplications = createSelector(
  selectUserApplications,
  orderBy('updated_at', 'desc')
)

export const selectLastUserApplication = createSelector(
  selectUserSortedApplications,
  first
)

export const selectCurrentApplication = createEntitiesSelector(
  selectCurrentApplicationId,
  applicationSchemas.denormalize
)

export const selectApplicationParamId = (_, props) => parseInt(props.match.params.id, 10)

export const selectApplyByParamsId = createEntitiesSelector(
  selectApplicationParamId,
  applicationSchemas.denormalize
)
